module.exports = __webpack_public_path__ + "img/img_manual3_5.b7d6c617.jpg";